// extracted by mini-css-extract-plugin
export default {"profileInfoRow":"cashier-profile_profileInfoRow__uMALG"};